/**
 * 
 */
import { RoomShort } from '@n3/ng-api-common';
import { Identity } from '@n3/ng-api-common';
import { EntityState } from '@n3/ng-api-common';
import { ClassifierShort } from '@n3/ng-api-common';
import { RoomSeat } from './roomSeat.model';
import { PlaceEquipment } from './placeEquipment.model';
export class Room extends RoomShort {
    public _isEmpty: boolean; /*указывает на то пустой ли объект*/
    public identity: Identity; /**/
    public entity_state: EntityState; /**/
    public number: string; /*Номер помещения*/
    public type: ClassifierShort; /**/
    public name: string; /*Наименование*/
    public seats: RoomSeat[]; /*Посадочные места в помещении*/
    public equipment: PlaceEquipment[]; /*Оснащение*/

    constructor(json?: any) {
        if (json === void 0 || json === null) {
            json = {};
        }
        super(json);

        this.identity = new Identity(json.identity);
        this.entity_state = new EntityState(json.entity_state);
        this.number = json.number || null;
        this.type = new ClassifierShort(json.type);
        this.name = json.name || null;
        this.seats = [];
        if (json.seats) {
          for (const i in json.seats) {
            if ( json.seats.hasOwnProperty( i ) ) {
                this.seats.push(new RoomSeat(json.seats[i]));
            }
          }
        }
        this.equipment = [];
        if (json.equipment) {
          for (const i in json.equipment) {
            if ( json.equipment.hasOwnProperty( i ) ) {
                this.equipment.push(new PlaceEquipment(json.equipment[i]));
            }
          }
        }
        this._isEmpty = this.isEmpty(this);
    }
}
